import React, { Component } from 'react';
import VkLogo from './vk_logo.png';
import TgLogo from './TgLogo.png';
import { HorizontalLine } from './HorizontalLine';
import {BeautifulCircleIcon}  from './BeautifulCircleIcon';
import { ActiveIcon } from './ActiveIcon';
import ActiveIconSecond from './ActiveIconSecond';


export class CreateWidgetChooseSocialNetwork extends React.Component {

    constructor(props) {
        super(props);
        this.refFileInputSmallImg = React.createRef();
        this.refFileInputBigImg = React.createRef();
    }

    render() {
        return (
            

        <div className='chooseNetworkBlock'>
            <div className='whiteBlockTitle'>
               <BeautifulCircleIcon/> 
               <div className="whiteBlockTitleSpan">
                Выберите социальную сеть, для которой создаете чат-бот + виджет на сайт
                </div>
            </div>
            <div className="chooseNetworkBlock_block_blocks whiteBlockMiddle">
                <div className='chooseNetworkBlock_block' onClick={ () =>  {
                    this.props.changeSocialNetwork("vk")
                }}>
                    <div className='chooseNetworkBlock_block_activated'>{
                        this.props.socialNetwork == 'vk' ? <ActiveIconSecond /> : null

                    } </div>
                    <img src={VkLogo} />
                    <div className='chooseNetworkBlock_block_name'>
                        Вконтакте
                    </div>
                    
                </div>
                

                <div className='chooseNetworkBlock_block'  onClick={ () =>  {
                    this.props.changeSocialNetwork("tg")
                }}>
                    
                    <div className='chooseNetworkBlock_block_activated'>{
                        this.props.socialNetwork == 'tg' ? <ActiveIconSecond /> : null

                    }</div>
                    <img src={TgLogo} />
                    <div className='chooseNetworkBlock_block_name'>
                        Телеграм
                    </div>
                    
                </div>
            
            </div>
            <div className="whiteBlockButtonBlock">
                <div onClick={this.props.goFurther} className='whiteBlockButton'>Продолжить</div>
            </div>
            
        </div>
        
               
        )
    }
}